import React, { Component } from 'react';
import { Tabs, Tab } from 'material-ui/Tabs';
import * as Colors from '../../utils/Color';


const styles = {
    tabItemContainerStyle: {
        color: Colors.primary,
        backgroundColor: Colors.secondary
    },
    inkBarStyle: {
        backgroundColor: Colors.primary
    },
    buttonStyle: {
        fontWeight: 700,
        color: Colors.primary
    }
};


class TabElement extends Component {

    render() {
        return (
            <Tabs tabItemContainerStyle={ styles.tabItemContainerStyle } inkBarStyle={ styles.inkBarStyle }>
                { this.props.children.map((content, i) => {
                    return <Tab onActive={ () => this.props.onTabChange(this.props.labels[i]) } key={i} label={this.props.labels[i]} buttonStyle={ styles.buttonStyle }>{content}</Tab>;
                }) }
            </Tabs>
        );
    }
}

export default TabElement;



// WEBPACK FOOTER //
// ./src/components/UI/Tabs.js